/**
 * Papéis de usuário — espelha o enum nativo `papel_usuario` do PostgreSQL
 * (`prisma/schema.prisma`) e `docs/spec/04-roles-permissions.md §1`.
 *
 * RNF-121: declarado UMA vez aqui e consumido pela API e pela web. Divergência
 * entre este arquivo e o schema Prisma é erro de build.
 */

export const PAPEIS = ['ADMINISTRADOR', 'GESTOR', 'SUPERVISOR', 'ATENDENTE'] as const

export type Papel = (typeof PAPEIS)[number]

/**
 * Hierarquia. Número maior = mais poder.
 *
 * Serve ao RN-71 ("nenhum usuário cria ou promove alguém a papel igual ou
 * superior ao seu"). É comparação de inteiros, não de strings — comparar
 * strings ordenaria SUPERVISOR acima de GESTOR.
 */
export const NIVEL_PAPEL: Readonly<Record<Papel, number>> = {
  ADMINISTRADOR: 40,
  GESTOR: 30,
  SUPERVISOR: 20,
  ATENDENTE: 10,
}

/**
 * Os quatro papéis de `PAPEIS` são atribuíveis. Não há mais lista de "liberados".
 *
 * `SUPERVISOR` era barrado por `PAPEIS_LIBERADOS_NO_MVP`/`papelLiberado()`, que
 * ficavam aqui e eram consultados pela API (409 ao criar) e pelos dois seletores da
 * web. A operação confirmou C18 de `04-roles-permissions.md §1` — a Baiocchi
 * trabalha com responsável de equipe no dia a dia —, então o portão saiu inteiro em
 * vez de virar uma constante com os quatro papéis: lista que não filtra nada é
 * convite a alguém reintroduzir um filtro errado depois.
 *
 * O que continua limitando quem recebe qual papel é `podeAtribuirPapel` (RN-71),
 * abaixo, mais `USUARIO_GERENCIAR_ADMINISTRADOR` no serviço — regras de hierarquia,
 * não de fase do projeto.
 */

/** RN-71. `true` quando `autor` pode atribuir `alvo` a outra pessoa. */
export function podeAtribuirPapel(autor: Papel, alvo: Papel): boolean {
  // Administrador é a única exceção da regra: ele cria outro administrador.
  if (autor === 'ADMINISTRADOR') return true
  return NIVEL_PAPEL[alvo] < NIVEL_PAPEL[autor]
}

export const ROTULO_PAPEL: Readonly<Record<Papel, string>> = {
  ADMINISTRADOR: 'Administrador',
  GESTOR: 'Gestor',
  SUPERVISOR: 'Supervisor',
  ATENDENTE: 'Atendente',
}
